import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      light: "#cbaf66",
      main: "#b48c24",
      dark: "#90701d",
    },
    secondary: { light: "#335275", main: "#002752", dark: "#001f42" },
    appBlue: { light: "#85C0FF", main: "#0063CC", dark: "#00458f" },
    success: { light: "#60a563", main: "#388e3c", dark: "#2d7230" },
    error: { light: "#dc5959", main: "#d32f2f", dark: "#a92626" },
    warning: { light: "#f6891a", main: "#f57c00", dark: "#dd7000" },
    bgColor: {
      main: "#F8F8F8",
    },
    white: {
      light: "#F8F8F8",
      main: "#ffffff",
      dark: "#999999",
      black: "#191919",
    },
  },
  typography: {
    fontFamily: `"Inter", sans-serif;`,
  },
  components: {
    MuiCardContent: {
      styleOverrides: {
        root: {
          "&:last-child": { padding: "1rem" },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        'root': {
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
        },
      },
    },
  },
});
